"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Text alignment',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.allowTitle || styleParams.allowDescription;
  },
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.galleryTextAlign.CENTER,
  options: (0, _utils.createOptions)('galleryTextAlign'),
  description: "This option sets the alignment (left, right or center) of each item in the gallery.\n  "
};
exports["default"] = _default;